import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  clearErrorAction,
  createProductAction,
} from "../redux/actions/productAction";
import swal from "sweetalert";
import { Button } from "@material-ui/core";
import Loader from "../layout/loader";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DescriptionIcon from "@material-ui/icons/Description";
import StorageIcon from "@material-ui/icons/Storage";
import SpellCheckIcon from "@material-ui/icons/Spellcheck";
import DiscountIcon from "@mui/icons-material/Discount";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Filter6Icon from "@mui/icons-material/Filter6";
import FilterVintageIcon from "@mui/icons-material/FilterVintage";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import PercentIcon from "@mui/icons-material/Percent";
import LinkIcon from "@mui/icons-material/Link";

import axios from "axios";
import Sidebar from "./Sidebar";
import "./createNewProduct.css";
import { NEW_PRODUCT_RESET } from "../redux/constants/productConstants";

const CreateNewProduct = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading, error, success } = useSelector(
    (state) => state.newProductCreate
  );

  const [name, setName] = useState("");
  const [tag, setTag] = useState("");
  const [slug, setSlug] = useState("");
  const [metaTag, setMetaTag] = useState("");
  const [price, setPrice] = useState("");
  const [discountActive, setDiscountActive] = useState("");
  const [discountPrice, setDiscountPrice] = useState("");
  const [qualityType, setQualityType] = useState("");
  const [keyword, setKeyword] = useState("");
  const [color, setColor] = useState([""]);
  const [size, setSize] = useState([""]);
  const [brand, setBrand] = useState("");
  const [descripation, setDescripation] = useState("");
  const [catogery, setCatogery] = useState("");
  const [stock, setStock] = useState("");
  const [offers, setOffers] = useState("");
  const [shippingCharges, setShippingCharges] = useState("");
  const [isdeliveryFree, setIsdeliveryFree] = useState("");
  const [image, setImage] = useState("");
  const [headImage, setheadImage] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [materials, setMaterials] = useState("");
  const [highlights, setHighlights] = useState("");
  const [catogeries, setCatogeries] = useState([]);

  useEffect(() => {
    let isMounted = true;
    axios.get("/api/categories")
      .then((res) => {
        if (isMounted && res.data && res.data.categories) {
          setCatogeries(res.data.categories.map((c) => c.name));
        }
      })
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (error) {
      swal({
        title: "Validation",
        text: error,
        icon: "error",
      });
      dispatch(clearErrorAction());
    }
    if (success) {
      swal({
        title: "Created.",
        text: success,
        icon: "success",
      });
      history.push("/Admin/dashboard");
      dispatch({ type: NEW_PRODUCT_RESET });
    }
  }, [dispatch, error, history, success]);

  // on click function when submit button press
  const createProductSubmitHandler = async (e) => {
    e.preventDefault();
    if (!image) {
      return swal({
        title: "Validation Error",
        text: "Please Select Images..!",
        icon: "info",
      });
    }
    let formData = new FormData();
    formData.append("name", name);
    formData.append("tag", tag);
    formData.append("slug", slug);
    formData.append("metaTag", metaTag);
    formData.append("keyword", keyword);
    formData.append("price", price);
    formData.append("qualityType", qualityType);
    formData.append("discountActive", discountActive);
    formData.append("discountPrice", discountPrice);
    formData.append("color", color);
    formData.append("size", size);
    formData.append("brand", brand);
    formData.append("descripation", descripation);
    formData.append("catogery", catogery);
    formData.append("stock", stock);
    formData.append("offers", offers);
    formData.append("shippingCharges", shippingCharges);
    formData.append("isdeliveryFree", isdeliveryFree);
    formData.append("videoUrl", videoUrl);
    formData.append("materials", materials);
    formData.append("highlights", highlights);

    for (let index = 0; index < image.length; index++) {
      formData.append("image", image[index]);
    }

    for (let index = 0; index < headImage.length; index++) {
      formData.append("headImage", headImage[index]);
    }

    dispatch(createProductAction(formData));
  };

  // // for images adding function

  const createProductImageChange = (e) => {
    setImage(e.target.files);
  };

  const setHeadImageProductChange = (e) => {
    setheadImage(e.target.files);
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="dashboard-container">
            <Sidebar />
            <div className="newProductContainer">
              <form
                className="createProductForm"
                onSubmit={createProductSubmitHandler}
              >
                <div className="create-product-hero">
                  <div>
                    <span>Admin product setup</span>
                    <h1>Create Product</h1>
                    <p>
                      Add clean product information, pricing, search details,
                      and images for the storefront.
                    </p>
                  </div>
                  <div className="create-product-progress">
                    <strong>{image?.length || 0}</strong>
                    <span>gallery images selected</span>
                  </div>
                </div>

                <section className="create-product-section">
                  <div className="create-product-section-head">
                    <span>01</span>
                    <div>
                      <h2>Product Identity</h2>
                      <p>Name, brand, category, and product quality details.</p>
                    </div>
                  </div>
                  <div className="create-product-grid">
                    <label className="create-product-field">
                      <span>Product name</span>
                      <div>
                        <SpellCheckIcon />
                        <input
                          type="text"
                          placeholder="Nike Air Max 90 Surplus"
                          required
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Product tag</span>
                      <div>
                        <LocalOfferIcon />
                        <input
                          type="text"
                          placeholder="New arrival, Best seller, Trending"
                          required
                          value={tag}
                          onChange={(e) => setTag(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>URL slug</span>
                      <div>
                        <LinkIcon />
                        <input
                          type="text"
                          placeholder="e.g., nike-air-jordan-white"
                          value={slug}
                          onChange={(e) => setSlug(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Brand</span>
                      <div>
                        <CheckCircleOutlineIcon />
                        <input
                          type="text"
                          placeholder="Nike"
                          required
                          value={brand}
                          onChange={(e) => setBrand(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Category</span>
                      <div>
                        <AccountTreeIcon />
                        <select
                          value={catogery}
                          onChange={(e) => setCatogery(e.target.value)}
                        >
                          <option value="">Choose category</option>
                          {catogeries.map((items) => (
                            <option key={items} value={items}>
                              {" "}
                              {items}{" "}
                            </option>
                          ))}
                        </select>
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Quality type</span>
                      <div>
                        <AutoAwesomeIcon />
                        <input
                          type="text"
                          placeholder="Example: 10A, 7A"
                          required
                          value={qualityType}
                          onChange={(e) => setQualityType(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Offer text</span>
                      <div>
                        <FilterVintageIcon />
                        <input
                          type="text"
                          placeholder="Free delivery, limited stock, etc."
                          required
                          value={offers}
                          onChange={(e) => setOffers(e.target.value)}
                        />
                      </div>
                    </label>
                  </div>
                </section>

                <section className="create-product-section">
                  <div className="create-product-section-head">
                    <span>02</span>
                    <div>
                      <h2>Search & SEO</h2>
                      <p>
                        Use customer-friendly words that match real searches.
                      </p>
                    </div>
                  </div>
                  <div className="create-product-grid">
                    <label className="create-product-field">
                      <span>SEO title / Google search</span>
                      <div>
                        <TravelExploreIcon />
                        <input
                          type="text"
                          placeholder="Buy Nike sneakers online in India"
                          required
                          value={metaTag}
                          onChange={(e) => setMetaTag(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Search keywords</span>
                      <div>
                        <KeyboardIcon />
                        <input
                          type="text"
                          placeholder="nike shoes, sports sneakers, air max"
                          required
                          value={keyword}
                          onChange={(e) => setKeyword(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field create-product-wide">
                      <span>Description</span>
                      <div>
                        <DescriptionIcon />
                        <textarea
                          placeholder="Write a clear product description for customers..."
                          required
                          value={descripation}
                          onChange={(e) => setDescripation(e.target.value)}
                          cols={10}
                          rows={1}
                        ></textarea>
                      </div>
                    </label>
                  </div>
                </section>

                <section className="create-product-section">
                  <div className="create-product-section-head">
                    <span>03</span>
                    <div>
                      <h2>Price, Stock & Delivery</h2>
                      <p>
                        Set inventory and the exact amount customers will see.
                      </p>
                    </div>
                  </div>
                  <div className="create-product-grid create-product-grid-three">
                    <label className="create-product-field">
                      <span>Price</span>
                      <div>
                        <AttachMoneyIcon />
                        <input
                          type="number"
                          placeholder="2199"
                          required
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Discount status</span>
                      <div>
                        <PercentIcon />
                        <select
                          value={discountActive}
                          onChange={(e) => setDiscountActive(e.target.value)}
                          required
                        >
                          <option value="">Select discount type</option>
                          <option value={"true"}>Active</option>
                          <option value={"false"}>Inactive</option>
                        </select>
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Discount amount</span>
                      <div>
                        <DiscountIcon />
                        <input
                          type="number"
                          placeholder="0"
                          required
                          value={discountPrice}
                          onChange={(e) => setDiscountPrice(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Shipping charge</span>
                      <div>
                        <LocalShippingIcon />
                        <input
                          type="number"
                          placeholder="60"
                          required
                          value={shippingCharges}
                          onChange={(e) => setShippingCharges(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Delivery type</span>
                      <div>
                        <AllInboxIcon />
                        <select
                          value={isdeliveryFree}
                          onChange={(e) => setIsdeliveryFree(e.target.value)}
                          required
                        >
                          <option value="">Select delivery type</option>
                          <option value={"true"}>Free</option>
                          <option value={"false"}>Charges applied</option>
                        </select>
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Stock</span>
                      <div>
                        <StorageIcon />
                        <input
                          type="number"
                          placeholder="100"
                          required
                          value={stock}
                          onChange={(e) => setStock(e.target.value)}
                        />
                      </div>
                    </label>
                  </div>
                </section>

                <section className="create-product-section">
                  <div className="create-product-section-head">
                    <span>04</span>
                    <div>
                      <h2>Variants & Media</h2>
                      <p>
                        Add colors, sizes, gallery images, and the main display
                        image.
                      </p>
                    </div>
                  </div>
                  <div className="create-product-grid">
                    <label className="create-product-field">
                      <span>Colors</span>
                      <div>
                        <ColorLensIcon />
                        <input
                          type="text"
                          placeholder="Black, White, Red"
                          required
                          value={color}
                          onChange={(e) => setColor(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Sizes</span>
                      <div>
                        <Filter6Icon />
                        <input
                          type="text"
                          placeholder="6, 7, 8, 9, 10"
                          required
                          value={size}
                          onChange={(e) => setSize(e.target.value)}
                        />
                      </div>
                    </label>
                  </div>
                  <div className="create-product-upload-grid">
                    <label
                      className="create-product-upload"
                      id="createProductFormFile"
                    >
                      <strong>Product gallery</strong>
                      <span>Upload multiple product images.</span>
                      <input
                        type="file"
                        name="image"
                        accept="image/*"
                        multiple
                        onChange={createProductImageChange}
                      />
                      <em>{image?.length || 0} images selected</em>
                    </label>
                    <label
                      className="create-product-upload"
                      id="createProductFormFile"
                    >
                      <strong>Hero image</strong>
                      <span>Upload the main product image.</span>
                      <input
                        type="file"
                        name="headImage"
                        accept="image/*"
                        onChange={setHeadImageProductChange}
                      />
                      <em>{headImage?.length || 0} image selected</em>
                    </label>
                  </div>
                </section>

                <section className="create-product-section">
                  <div className="create-product-section-head">
                    <span>05</span>
                    <div>
                      <h2>Rich Specifications</h2>
                      <p>
                        Add product showcase video link, materials details, and key highlights.
                      </p>
                    </div>
                  </div>
                  <div className="create-product-grid">
                    <label className="create-product-field">
                      <span>Video walkthrough URL</span>
                      <div>
                        <LinkIcon />
                        <input
                          type="text"
                          placeholder="https://example.com/video.mp4"
                          value={videoUrl}
                          onChange={(e) => setVideoUrl(e.target.value)}
                        />
                      </div>
                    </label>
                    <label className="create-product-field">
                      <span>Highlights (Comma separated)</span>
                      <div>
                        <KeyboardIcon />
                        <input
                          type="text"
                          placeholder="Breathable fit, Active cushioning, Traction grip"
                          value={highlights}
                          onChange={(e) => setHighlights(e.target.value)}
                        />
                      </div>
                    </label>
                  </div>
                  <div className="create-product-grid create-product-wide" style={{ marginTop: '15px' }}>
                    <label className="create-product-field create-product-wide">
                      <span>Materials & Care</span>
                      <div>
                        <DescriptionIcon />
                        <textarea
                          placeholder="Premium leather and synthetic upper construct..."
                          value={materials}
                          onChange={(e) => setMaterials(e.target.value)}
                          cols={10}
                          rows={2}
                        ></textarea>
                      </div>
                    </label>
                  </div>
                </section>

                <div className="create-product-submit-row">
                  <Button
                    id="createProductBtn"
                    type="submit"
                    disabled={loading ? true : false}
                  >
                    Create Product
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default CreateNewProduct;
